import {Component, ContentChildren, QueryList} from '@angular/core';
import {TabItemPropertyComponent} from '../tab-item/tab-item-property.component';
import { PropertyService } from 'app/views/admin/property/services/property.service';

declare const $: any;
declare const window: any;

@Component({
    selector: 'tabs-wrapper-property',
    templateUrl: './tabs-wrapper-property.component.html',
    styleUrls: ['./tabs-wrapper-property.component.scss'],
})
export class TabsWrapperPropertyComponent {
    @ContentChildren(TabItemPropertyComponent) tabs: QueryList<TabItemPropertyComponent>;

    constructor(public propertyService: PropertyService) {
    }

    selectTab(tab: TabItemPropertyComponent) {
        if (this.isActiveTab(tab.id)) return;

        this.tabs.toArray().forEach((t) => t.active = false);
        tab.active = true;
    }

    isActiveTab(tabId: string): boolean {
        return !!this.tabs.toArray().find((item) => item.active && item.id === tabId);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/tabs/tabs-wrapper/tabs-wrapper-property.component.ts